import { render } from "./question.vue?vue&type=template&id=07cdf4bd"
const script = {}

import exportComponent from "C:\\Build\\vsts-agent-win-x64-3.218.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__